import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=6cba8c0c&scoped=true"
import script from "./LabelValue.vue?vue&type=script&lang=ts"
export * from "./LabelValue.vue?vue&type=script&lang=ts"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=6cba8c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba8c0c",
  null
  
)

export default component.exports